import { z } from "zod";
export const zTariffCommonSchema = z.object({
    id: z.string(),
    idServiceZone: z.string(),
    name: z.string(),
    type: z.string(),
    pricePerKwh: z.number().nullish(),
    oneTimeServiceFee: z.number(),
    emergencyServiceFee: z.number().nullish(),
    subscriptionPrice: z.number().nullish(),
    // —— FR-003: subscription fields already in DB, backfilled into FE schema ——
    subscriptionDurationDays: z.number().int().nullish(),
    subscriptionKwhLimit: z.number().nullish(),
    subscriptionVisitLimit: z.number().int().nullish(),
    rolloverType: z.string().nullish(),
    overLimitPricePerKwh: z.number().nullish(),
    overLimitVisitPrice: z.number().nullish(),
    isDefault: z.boolean().default(false),
    // —— FR-003: pair-aware fields ——
    isLateTwin: z.boolean().default(false),
    idLateTariff: z.string().nullish(),
    cutoffHourMsk: z.number().int().min(0).max(23).nullish(),
    cutoffOffsetDays: z.number().int().min(-7).max(0).nullish(),
    // —— Existing tail ——
    validFrom: z.string(),
    validTo: z.string().nullish(),
    isActive: z.boolean(),
    createdAt: z.string().nullish(),
    updatedAt: z.string().nullish(),
    isDeleted: z.boolean().nullish(),
    idCreatedBy: z.string().nullish(),
    idUpdatedBy: z.string().nullish(),
});
export const zTariffFiltersSchema = z.object({
    search: z.string().optional(),
});
// —— FR-003: pair-list filters ——
export const zTariffPairFiltersSchema = z.object({
    search: z.string().optional(),
    type: z.string().optional(), // ONE_TIME | SUBSCRIPTION_AMOUNT | SUBSCRIPTION_VISITS | EMERGENCY
    isActive: z.boolean().optional(),
});
